import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "socialFacebook"
const SocialFacebookIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M20.5 4.875v13.75c0 .52-.182.964-.547 1.328a1.808 1.808 0 0 1-1.328.547h-3.32v-6.914h2.343L18 10.93h-2.695V9.25c0-.417.078-.73.234-.938.208-.234.56-.351 1.055-.351H18V5.617c-.547-.078-1.224-.117-2.031-.117-1.042 0-1.869.306-2.48.918-.613.612-.919 1.465-.919 2.559v1.953h-2.383v2.656h2.383V20.5H4.875c-.52 0-.964-.182-1.328-.547A1.808 1.808 0 0 1 3 18.625V4.875c0-.52.182-.964.547-1.328A1.808 1.808 0 0 1 4.875 3h13.75c.52 0 .964.182 1.328.547.365.364.547.807.547 1.328z" />
        </svg>
      }
    </span>
  )
}
export default SocialFacebookIcon
